import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { PUZZLE_CONFIG } from '../config/puzzleConfig';
import PuzzlePiece from './PuzzlePiece';

const PuzzleArea = styled.div`
  opacity: ${props => props.isOverlay ? '0' : '1'};
  ${props => props.isOverlay && 'transition: opacity 0.3s ease;'};
  pointer-events: ${props => props.isOverlay ? 'none' : 'auto'};
  position: relative;
  width: ${props => PUZZLE_CONFIG.dimensions[props.size].width}px;
  height: ${props => PUZZLE_CONFIG.dimensions[props.size].height}px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;

  @media (max-width: 768px) {
    width: 300px;
    height: 300px;
    padding: 15px;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    width: 250px;
    height: 250px;
    padding: 10px;
  }
`;

const PuzzleGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(${props => props.size}, 1fr);
  grid-template-rows: repeat(${props => props.size}, 1fr);
  gap: 0;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const PuzzleCell = styled(motion.div)`
  width: 100%;
  height: 100%;
  background: ${props => props.isEmpty ? 'rgba(0, 0, 0, 0.5)' : 'transparent'};
  border: ${props => props.isEmpty ? '2px dashed rgba(255, 255, 255, 0.8)' : 'none'};
  cursor: ${props => props.isEmpty ? 'default' : 'pointer'};
  transition: all 0.3s ease;
  user-select: none;
  position: relative;
  
  &:hover {
    background: ${props => props.isEmpty ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.1)'};
  }
`;

const PuzzleBoard = ({ 
  puzzle, 
  size, 
  imageUrl, 
  movingPiece, 
  isOverlay,
  onPieceClick 
}) => {
  const emptyIndex = size * size - 1;

  return (
    <PuzzleArea size={size} isOverlay={isOverlay}>
      <PuzzleGrid size={size}>
        {/* 빈 셀들 먼저 렌더링 */}
        {puzzle.map((pieceIndex, cellIdx) => {
          const isEmpty = pieceIndex === emptyIndex;
          return (
            <PuzzleCell
              key={`cell-${cellIdx}`}
              isEmpty={isEmpty}
            />
          );
        })}
        
        {/* 조각들을 별도로 렌더링하여 실제 슬라이드 애니메이션 구현 */}
        <AnimatePresence>
          {puzzle.map((pieceIndex, cellIdx) => {
            const isEmpty = pieceIndex === emptyIndex;
            const isCorrectPosition = pieceIndex === cellIdx;
            
            if (isEmpty) return null;
            
            return (
              <PuzzlePiece
                key={`piece-${pieceIndex}`}
                pieceIndex={pieceIndex}
                size={size}
                imageUrl={imageUrl}
                isMoving={movingPiece === pieceIndex}
                isCorrectPosition={isCorrectPosition}
                onClick={e => onPieceClick(pieceIndex, e)}
                layoutId={`piece-${pieceIndex}`}
                cellIndex={cellIdx}
              />
            );
          })}
        </AnimatePresence>
      </PuzzleGrid>
    </PuzzleArea>
  );
};

export default PuzzleBoard; 